<template>
  <v-app transition="fade-transition">
    <v-card tile transition="fade-transition">
      <div class="container container--fluid">
        <v-layout wrap justify-center mb-2>
          <v-flex class="content xs12 md7" style="height:100vh">
            <iframe class="profile-iframe" :src="formUrl" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0" title="Travel"></iframe>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-app>
</template>
<script>
export default {
  name: 'ProfileTallyForm',
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    close() {
      this.$router.push({path: '/'})
    }
  },
  computed: {
    formUrl() {
      let url = 'https://tally.so/r/mJLz4Y?transparentBackground=1'
      let query = this.$route.query
      if (query.igHandle) {
        url += '&igHandle=' + query.igHandle
      }
      if (query.tiktokHandle) {
        url += '&tiktokHandle=' + query.tiktokHandle
      }
      if (query.influencerID) {
        url += '&influencerID=' + query.influencerID
      }
      return url
    }
  },
  mounted() {
    // implement
  }
}
</script>
<style>
  .profile-iframe { position: absolute; top: 0; right: 0; bottom: 0; left: 0; border: 0; height: 100vh; }
</style>
<style lang="scss">
  .v-dialog--fullscreen {
    scroll-behavior: smooth;
  }
</style>
<style scoped>
  html {
    overflow-y: hidden!important;
  }

  .bg-soft-grey {
    background-color: #f6f6f6;
  }

  .bg--white {
    background-color: #fff;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .form-label {
    min-height: 22px;
  }

  .caption-text {
    color: #f79d18;
  }

  /* .td-error {
    margin-bottom: -20px;
    right: 16px;
  } */

  .td-error, .alert-error {
    display: inline-block;
    font-size: 12px;
    right: 15px;
    padding: 5px;
    margin-bottom: 0px;
    color: #fff!important;
  }

  .alert-error {
    right: 0
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .d-sm-table-cell {
    height: auto!important;
    padding: 0;
    padding-left: 15px;
  }

  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    background-color: #fff;
    padding: 20px;
  }

  .avatar-logo {
    width: 120px!important;
    min-width: 120px!important;
    height: auto!important;
    transition: all 0.5s ease-out;
  }

  .avatar-logo img {
    width: 120px;
  }
  
  .form-title {
    margin-top: 0;
    text-align: center;
    font-weight: 600;
    /* padding: 40px; */
    transition: all 0.5s ease-out;
  }

  .label-stats {
    min-width: 170px;
    float: left;
    margin-right: 20px;
    padding-top: 15px;
  }
  .event-att-section {
    margin-top: 100px;
  }

  .currency-select {
    width: 86px;
    max-width: 60px;
    font-size: 12px;
  }

  .no-boxshadow {
    box-shadow: none!important;
  }

  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }
  
  @media (max-width: 600px) {
    .content {
      padding: 0;
    }
    .avatar-logo {
      height: auto!important;
      min-width: 100%!important;
      width: 100%!important;
    }
    
    .form-title {
      float: none;
      padding: 0;
      font-size: 25px;
      width: 100%;
      text-align: center;
    }

    .float-xs-left {
      float: left;
    }

    .td-error, .alert-error {
      width: 100%;
      right: 0;
    }

    .pt-xs-5 {
      padding-top: 15px
    }

    .mb-xs-0 {
      margin-bottom: 0;
    }
  }

  /* @media (max-width: 400px) {
    .platform-select {
      min-width: 50px!important;
      max-width: 50px!important;
    }
  } */

  @media (min-width: 1000px) and (max-width: 1366px) {
    .content {
      flex-basis: 90%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Form.vue?e0983efe